import styled from "styled-components";

export const ProductCategoryTitle = styled.h3`
  font-weight: 800;
  margin: 20px 0;
`;
